import { BrandNoteTypeEnum } from "@nlc/shared-types";

export const noteTypeOptions = [
  { label: "Requirements", value: BrandNoteTypeEnum.REQUIREMENTS },
  { label: "Preferences", value: BrandNoteTypeEnum.PREFERENCES },
  {
    label: "Context & references",
    value: BrandNoteTypeEnum.CONTEXT_REFERENCES,
  },
];
